import React, { Component } from 'react';
import { isEqual } from 'lodash';
import classNames from 'classnames';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import { alignment, exceptionComponentPageTypes } from '../../constants/globals';

import ExceptionEmoji from '../../assets/images/exception-emoji.svg';
import './ExceptionComponent.scss';

const Button = asyncRoute(() => import('../MaterialElements/Button'));
const Segment = asyncRoute(() => import('../elements/SegmentComponent'));

export default class ExceptionComponent extends Component {
  renderSegmentComponent() {
    const {
      title,
      description,
      buttonCta,
      handleButtonCta,
      showEmoji,
      contentAlignment,
      respectPrelineSpaces,
    } = this.props;
    return (
      <div className={`exception exception-halfSize align-content-${contentAlignment}`}>
        {showEmoji && (
          <div className="exception-emoji">
            <img src={ExceptionEmoji} alt="exception-emoji-icon" />
          </div>
        )}
        <p className="exception-title">{title}</p>
        <p className={`exception-description ${respectPrelineSpaces ? 'space-pre-line' : ''}`}>
          {description}
        </p>
        {buttonCta && handleButtonCta && <Button onClick={handleButtonCta} content={buttonCta} />}
      </div>
    );
  }

  render() {
    const {
      pageType,
      title,
      description,
      buttonCta,
      handleButtonCta,
      openSegmentPopup,
      dismissSegmentPopup,
      showEmoji,
      themeContext,
    } = this.props;

    return (
      <>
        {isEqual(pageType, exceptionComponentPageTypes.halfSize) ? (
          <Segment
            classList={'exception_popup'}
            openPopup={openSegmentPopup}
            dismissPopup={dismissSegmentPopup}
            children={this.renderSegmentComponent()}
          />
        ) : (
          <div className={classNames('exception exception-fullSize', themeContext)}>
            {showEmoji && (
              <div className="exception-emoji">
                <img src={ExceptionEmoji} alt="exception-emoji-icon" />
              </div>
            )}
            <p className="exception-title">{title}</p>
            <p className="exception-description">{description}</p>
            {buttonCta && handleButtonCta && (
              <div className="exception-cta">
                <Button onClick={handleButtonCta} content={buttonCta} />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

ExceptionComponent.defaultProps = {
  showEmoji: true,
  contentAlignment: alignment.center,
  respectPrelineSpaces: false,
};
